<template>
  <div class="loading">
    <p class="progress"></p>
    <p class="tip">加载中..</p>
  </div>
</template>
<script>
export default {
  name: 'Loading'
}
</script>
<style scoped lang="stylus">
  @import '~@/style/variable.styl'
  .loading
    min-height 30px
    line-height 1.5
    text-align center
    padding 10px 0
    p
      margin 0
    .progress
      display inline-block
      width 16px
      height 16px
      border-radius 50%
      border 1px solid $color-gray
      margin-right 8px
      border-bottom-color transparent
      vertical-align middle
      animation scrollRotate .6s linear infinite
      -webkit-animation scrollRotate .6s linear infinite
    .tip
      display inline-block
      font-size 12px
      color $color-gray
      vertical-align middle
  @keyframes scrollRotate
    0%
      transform rotate(0deg)
    100%
      transform rotate(360deg)
</style>



// WEBPACK FOOTER //
// src/base-component/loading/index.vue